import React from 'react';
import Block from 'common/components/TouchpointEditor/components/TouchpointNodes/Block';

export default function FooterContainer(props) {
    return <Block {...props} />;
}

FooterContainer.splash = {
    ...Block.splash,
    defaultProps: {
        ...Block.splash.defaultProps,
        styles: {
            ...Block.splash.defaultProps.styles,
            backgroundColor: '',
        },
    },
};
